import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import {firebaseConfig} from './utils/FirebaseConfig';
import firebase from 'firebase';
import WithTracker from './utils/WithTracker';
import {store, history} from './redux/store';
import {createFirebaseAuthUI, initAuthStateChangeHandler} from './redux/actions';
import { Provider } from 'react-redux';
import { Route } from 'react-router';
import { ConnectedRouter } from 'react-router-redux';

// Style imports
import 'semantic-ui-css/semantic.min.css';
import 'firebaseui/dist/firebaseui.css';

firebase.initializeApp(firebaseConfig);
store.dispatch(createFirebaseAuthUI());
store.dispatch(initAuthStateChangeHandler());

ReactDOM.render(
    <Provider store={store}>
        <ConnectedRouter history={history}>
            <Route component={WithTracker(App)} />
        </ConnectedRouter>
    </Provider>,
    document.getElementById('root'),
);

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js